import { createFileRoute } from "@tanstack/react-router"

import { DataSources } from "@/pages/DataSources"

export const Route = createFileRoute("/data-sources")({
  component: DataSources,
})
